import React, { useEffect, useState } from 'react';
import CategorySlider from "./CategorySlider";
import { useDispatch, useSelector } from 'react-redux';
import './slider.css';
import { setCategoryNavClicked } from 'redux/actions';

function SliderViewCategories() {
    const {fetchedData:{categories}, theme:{locale}} = useSelector(state => state)
    const dispatch = useDispatch()

    return (
        <>
            <div className={`menu-tabs d-flex align-items-center vvff`}>
                {categories?.map((category, index) =>{
                    if (category?.products?.length>0){
                        return <li 
                            key={index}
                            id={"id" + index}
                            className={`menu-tab ${index === 0 ? "active" : ''}`}
                            onClick={(element) => dispatch(setCategoryNavClicked({element, index}))}
                        >
                            {locale==='en' ? category?.nameEng : category?.nameAr}
                        </li>
                    }
                })}
            </div>

            <div className="menu-items">
                {categories?.map((category, index) => {
                    if (category?.products?.length>0){
                        return <div id={"id" + index} className="scrolling-category-block" key={category?.id}>
                            <CategorySlider key={category.id} category={category}/>
                        </div>
                    }
                })}
            </div>
        </>
    );
}

export default SliderViewCategories;